export * from "./Controls/_Public";
export * from "./Enums/_Public";
export * from "./Grids/_Public";
export * from "./Service/_Public";
export * from "./Configuration/_Public";
export * from "./Core/Events/EventTypes/_Public";

import {
    CoreContext as DMSCoreContext,
    QueryParameter as DMSQueryParameter,
    ApplicationParameter as DMSApplicationParameter,
    Navigation as DMSNavigation,
    ParentChild as DMSParentChild,
    Util as DMSUtil,
    Login as DMSLogin
} from "./Core";
import { ServiceProvider as DMSServiceProvider } from "Service";
import {
    reloadGrids as DMSreloadGrids,
    hideGrids as DMShideGrids,
    isV4 as DMSisV4,
    initializeMappingInContainer as DMSinitializeMappingInContainer
} from "Core";
import { TooltipExtension as DMSTooltipExtension } from "Grids/Extension";

export const QueryParameter = DMSQueryParameter;
export const ApplicationParameter = DMSApplicationParameter;
export const Navigation = DMSNavigation;
export const ParentChild = DMSParentChild;
export const Login = DMSLogin;
export const Util = DMSUtil;
export const reloadGrids = DMSreloadGrids;
export const hideGrids = DMShideGrids;
export const isV4 = DMSisV4;
export const initializeMappingInContainer = DMSinitializeMappingInContainer;
export const TooltipExtension = DMSTooltipExtension;

/**
 * @hidden
 */
export const Context = DMSCoreContext;
export const Service = DMSCoreContext.serviceProviderInstance;
export const ServiceProvider = DMSServiceProvider;
